export default function formatPhoneNumber(phone) {
  return `\u200E${phone}`;
}
